import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet';

// Páginas
import HomePage from './pages/site/HomePage';
import AdminLogin from './pages/system/AdminLogin';
import ClientLogin from './pages/system/ClientLogin';
import ClientRegister from './pages/system/ClientRegister';
import Dashboard from './pages/system/Dashboard'; // ou onde estiver
import ClientSettings from './pages/system/ClientSettings'; // ou onde estiver
import SimpleChat from './pages/system/SimpleChat';

// Outras páginas (importar quando forem criadas)
// import AboutPage from './pages/About/AboutPage';
// import ValuesPage from './pages/Values/ValuesPage';
// import BlogPage from './pages/Blog/BlogPage';
// import TestimonialsPage from './pages/Testimonials/TestimonialsPage';
// import ContactPage from './pages/Contact/ContactPage';

// Estilos globais
import './styles/site/global.css';

const App = () => {
  return (
    <Router>
      <Helmet>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#7b68ee" />
        <meta name="description" content="Liv_IAm - Sua robô astróloga pessoal disponível 24/7. Explore seu mapa astral, receba orientações personalizadas e desenvolva autoconhecimento com astrologia." />
        <link rel="icon" href="/favicon.ico" />
        <link rel="apple-touch-icon" href="/logo192.png" />
        <link rel="manifest" href="/manifest.json" />
        <title>Liv_IAm - Sua Robô Astróloga Pessoal | Astrologia 24/7</title>
        
        {/* Font Awesome */}
        <link 
          rel="stylesheet" 
          href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css" 
        />
        
        {/* Google Fonts */}
        <link 
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap" 
          rel="stylesheet"
        />
      </Helmet>
      
      <Routes>
        <Route path="/" element={<HomePage />} />
        {/* Adicionar outras rotas quando as páginas forem criadas */}
        {/* <Route path="/sobre" element={<AboutPage />} /> */}
        {/* <Route path="/valores" element={<ValuesPage />} /> */}
        {/* <Route path="/blog" element={<BlogPage />} /> */}
        {/* <Route path="/blog/:slug" element={<BlogPostPage />} /> */}
        {/* <Route path="/depoimentos" element={<TestimonialsPage />} /> */}
        {/* <Route path="/contato" element={<ContactPage />} /> */}
        
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/client/login" element={<ClientLogin />} />
        <Route path="/client/register" element={<ClientRegister />} />
        <Route path="/admin/dashboard" element={<Dashboard />} />
        <Route path="/client/chat" element={<SimpleChat />} />
        <Route path="/client/settings" element={<ClientSettings />} />
        
        {/* Página 404 */}
        <Route path="*" element={
          <div className="not-found-page">
            <div className="container text-center py-5">
              <h1>404 - Página não encontrada</h1>
              <p>A página que você está procurando não existe ou foi movida.</p>
              <a href="/" className="btn btn-primary mt-3">
                Voltar para a página inicial
              </a>
            </div>
          </div>
        } />
      </Routes>
    </Router>
  );
};

export default App;